export default "__VITE_ASSET__CPf73MlQ__"